import { useIntl } from 'react-intl';

import { FeaturedInfoCard } from '@/components/adg4/featured-info-card/src/featured-info-card';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { Ai } from '../../../../../../patterns/ai-section/src/ai';
import {
	FeaturedInfoSection,
	LAUNCH,
} from '../../../features/jira-software-features-page/src/sections-v2/featured-info/featured-info';
import {
	TimelineIcon,
	RedoIcon,
	FastIcon,
} from '../../../features/jira-software-features-page/src/sections-v2/featured-info/launch';

export const AiRefreshSection = () => {
	const intl = useIntl();

	const useGWP7617Gate = checkFeatureFlagGate(featureFlags.gwp7617JiraShortTermAiInfusionGate);

	if (useGWP7617Gate) {
		return (
			<FeaturedInfoSection
				variant={LAUNCH}
				eyebrow={intl.formatMessage({
					id: 'JiraSoftwarePageTemplate.AiRefreshSection.eyebrow',
					defaultMessage: 'Plan, Track, and Collaborate',
				})}
				header={intl.formatMessage({
					id: 'JiraSoftwarePageTemplate.AiRefreshSection.heading',
					defaultMessage: 'Where your team + AI come together',
				})}
				description={intl.formatMessage({
					id: 'JiraSoftwarePageTemplate.AiRefreshSection.description',
					defaultMessage: 'Jira’s AI helps teams drive better outcomes, faster.',
				})}
			>
				<FeaturedInfoCard
					video={{
						src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/374p64xck763gywok4l212n24sji512r.mp4',
						controls: false,
						autoplay: true,
						muted: true,
						loop: true,
						width: 1300,
						height: 694,
					}}
					Icon={TimelineIcon}
					title={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card1.Title',
						defaultMessage: 'Jumpstart planning',
					})}
					body={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card1.Description',
						defaultMessage:
							'Create work items from your favorite tools, then use AI to break down big ideas, polish descriptions, and link relevant resources in a snap.',
					})}
				/>

				<FeaturedInfoCard
					image={{
						image: {
							// eslint-disable-next-line local/no-non-orangelogic-images-eslint
							src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/workflow-builder.webp',
							alt: intl.formatMessage({
								id: 'JiraSoftwarePage.AiRefreshSection.Card2.ImageAlt',
								defaultMessage: 'Shared release date module in Jira',
							}),
						},
					}}
					Icon={RedoIcon}
					title={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card2.Title',
						defaultMessage: 'Focus on impact',
					})}
					body={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card2.Description',
						defaultMessage:
							'Cut down on admin with AI agents that make it easier to create project plans, identify trends, and flag potential risks.',
					})}
					ctaProps={{
						link: {
							text: intl.formatMessage({
								id: 'JiraSoftwarePage.AiRefreshSection.Card2.LinkText',
								defaultMessage: 'Meet Rovo agents',
							}),
							href: '/software/rovo/use-cases?feature=agent&',
						},
					}}
				/>

				<FeaturedInfoCard
					image={{
						image: {
							// eslint-disable-next-line local/no-non-orangelogic-images-eslint
							src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/linked-work-items.webp',
							alt: intl.formatMessage({
								id: 'JiraSoftwarePage.AiRefreshSection.Card3.ImageAlt',
								defaultMessage: 'Shared release date module in Jira',
							}),
						},
					}}
					Icon={FastIcon}
					title={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card3.Title',
						defaultMessage: 'Stay in sync',
					})}
					body={intl.formatMessage({
						id: 'JiraSoftwarePage.AiRefreshSection.Card3.Description',
						defaultMessage:
							'Surface related work, summarize lengthy comments, and connect work to company goals to give your team the details they need to work faster and make better decisions.',
					})}
					ctaProps={{
						link: {
							text: intl.formatMessage({
								id: 'JiraSoftwarePage.AiRefreshSection.Card3.LinkText',
								defaultMessage: 'Explore AI features',
							}),
							href: '/software/jira/ai',
						},
					}}
				/>
			</FeaturedInfoSection>
		);
	}
	return <Ai />;
};
